const React = require('react');
const { useEffect, useState } = React;
const { createElement: h } = React;
const apiClient = require('../lib/apiClient');
const VariableAutocompleteInput = require('./VariableAutocompleteInput');

function useConnectionStatus() {
  const [status, setStatus] = useState({ connected: false, checked: false });
  useEffect(function() {
    let cancelled = false;
    function check() {
      apiClient.request('/browser-action/status', { method: 'GET' })
        .then(function(result) {
          if (!cancelled) setStatus({ connected: !!(result && result.connected), checked: true });
        })
        .catch(function() {
          if (!cancelled) setStatus({ connected: false, checked: true });
        });
    }
    check();
    const timer = setInterval(check, 4000);
    return function() { cancelled = true; clearInterval(timer); };
  }, []);
  return status;
}

function Section(props) {
  return h('div', { className: 'wf-ba-section' },
    h('div', { className: 'wf-ba-section-head' },
      h('span', { className: 'wf-ba-badge' }, props.number),
      h('span', { className: 'wf-ba-section-label' }, props.label),
      props.required ? h('span', { className: 'wf-ba-required' }, 'Required') : null
    ),
    h('div', { className: 'wf-ba-section-body' }, props.children)
  );
}

function BrowserAgenticActionEditor(props) {
  const values = props.paramValues || {};
  const change = props.onParamChange || function() {};
  const nodeId = props.nodeId || '';
  const variableNodes = props.variableNodes || [];
  // Browser nodes that run BEFORE this one (nearest first). With no explicit
  // pick, Auto continues from the nearest one — the last used tab.
  const browserNodes = (props.browserActionNodes || []).filter(function(node) {
    return node && node.id !== nodeId;
  });
  const connection = useConnectionStatus();
  const task = String(values.task || '');
  const url = String(values.url || '');
  const tabMode = String(values.tabMode || 'new');
  const continueFrom = String(values.continueFrom || '');
  const autoSource = tabMode === 'continue' && !continueFrom && browserNodes.length
    ? browserNodes[0]
    : null;

  return h('div', { className: 'wf-ba-form' },
    h(Section, { number: 1, label: 'Browser tab' },
      h('select', {
        className: 'wf-params-input',
        value: tabMode,
        onChange: function(event) { change('tabMode', event.target.value); }
      },
        h('option', { value: 'new' }, 'Open a new tab'),
        h('option', { value: 'continue' }, 'Continue from a previous browser node')
      ),
      tabMode === 'continue'
        ? (browserNodes.length > 0
            ? h(React.Fragment, null,
                h('select', {
                  className: 'wf-params-input',
                  value: continueFrom,
                  onChange: function(event) { change('continueFrom', event.target.value); }
                },
                  h('option', { value: '' }, 'Auto — use the last used tab'),
                  browserNodes.map(function(node) {
                    return h('option', { key: node.id, value: node.id }, node.title + (node.url ? ' — ' + node.url : ''));
                  })
                ),
                autoSource ? h('div', { className: 'wf-ba-conn-hint' },
                  'Continues from: ', autoSource.title) : null
              )
            : h('div', { className: 'wf-ba-conn-hint' },
                'No browser node runs before this one — a new tab will be opened.'))
        : null
    ),
    h(Section, { number: 2, label: 'Webpage URL', required: tabMode !== 'continue' },
      h(VariableAutocompleteInput, {
        value: url,
        placeholder: tabMode === 'continue' ? 'Optional: keep the inherited page' : 'https://example.com',
        variableNodes: variableNodes,
        onChange: function(next) { change('url', next); }
      })
    ),
    h(Section, { number: 3, label: 'Task', required: true },
      h(VariableAutocompleteInput, {
        value: task,
        multiline: true,
        rows: 5,
        placeholder: 'Describe the exact result to complete in the browser. Use @ for variables.',
        variableNodes: variableNodes,
        onChange: function(next) { change('task', next); }
      }),
      h('div', { className: 'wf-ba-conn-hint' }, 'The agent works from fresh browser screenshots and stops immediately when the Task is visibly complete.')
    ),
    h(Section, { number: 4, label: 'After completion' },
      h('label', { className: 'wf-ba-check' },
        h('input', {
          type: 'checkbox',
          checked: String(values.closeTab || '') === 'true',
          onChange: function(event) { change('closeTab', event.target.checked ? 'true' : ''); }
        }),
        h('span', null, 'Close the browser tab after this node finishes')
      )
    ),
    !connection.connected && connection.checked ? h('div', {
      className: 'wf-ba-conn-hint', style: { marginTop: 14 }
    }, 'Browser Action extension not connected. Load it in Chrome and keep Chrome open.') : null
  );
}

module.exports = BrowserAgenticActionEditor;
